// extracted by mini-css-extract-plugin
export default {"login":"LoginLayout_login__r305Q","container":"LoginLayout_container__q4ZqA","logo":"LoginLayout_logo__xvV79","animation":"LoginLayout_animation__XseHD"};